import { http } from '../../config/axios'

export default function postNotificacao(notificacao: any): Promise<string> {
  return http
    .post('api/notificacao', notificacao)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post notificacao', error)
      throw Error(error.response.data)
    })
}
